import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { CheckCircle } from "@phosphor-icons/react";
import { toast } from "sonner";
import { formatDate, formatTime } from "@/lib/api";

export default function ConfirmLessonDialog({ lesson, open, onOpenChange, onConfirmed }) {
  const [subject, setSubject] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) setSubject(lesson?.subject || "");
  }, [open, lesson]);

  async function confirm() {
    if (!lesson) return;
    setSaving(true);
    try {
      await api.post(`/lessons/${lesson.id}/confirm`, { subject: subject.trim() });
      toast.success("Ders tamamlandı olarak kaydedildi.");
      onOpenChange(false);
      onConfirmed?.();
    } catch (e) {
      toast.error("Onaylama başarısız.");
    } finally {
      setSaving(false);
    }
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="font-display flex items-center gap-2">
            <CheckCircle size={22} weight="duotone" className="text-[#3A5A40]" />
            Dersi Tamamla
          </DialogTitle>
          {lesson && (
            <DialogDescription>
              <span className="font-medium text-foreground">{lesson.student_name}</span>
              {" · "}
              {formatDate(lesson.start_time)} · {formatTime(lesson.start_time)}–{formatTime(lesson.end_time)}
            </DialogDescription>
          )}
        </DialogHeader>
        <div className="space-y-3 py-2">
          <div className="space-y-1.5">
            <Label htmlFor="topic">İşlenen Konu</Label>
            <Input
              id="topic"
              placeholder="Örn: Türev, İkinci dereceden denklemler…"
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
              autoFocus
              data-testid="confirm-topic-input"
              onKeyDown={(e) => { if (e.key === "Enter") confirm(); }}
            />
            <p className="text-xs text-muted-foreground">
              Bu derste ne anlatıldı? Girdiğiniz konu aylık raporda veliye görünecek.
            </p>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} disabled={saving}>Vazgeç</Button>
          <Button
            onClick={confirm}
            disabled={saving}
            className="bg-[#3A5A40] hover:bg-[#2E4833] text-white"
            data-testid="confirm-topic-save"
          >
            {saving ? "Kaydediliyor…" : "Tamamla"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
